import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

const InventoryManager = () => {
  const [inventory, setInventory] = useState([]);
  const [newItem, setNewItem] = useState({
    nombre: '',
    categoria: 'material',
    stock: 0,
    stockMinimo: 5
  });

  const fetchInventory = async () => {
    const res = await fetch(`${API_URL}/api/inventario`);
    const data = await res.json();
    setInventory(data);
  };

  useEffect(() => {
    fetchInventory();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewItem(prev => ({
      ...prev,
      [name]: name === 'stock' || name === 'stockMinimo' ? Number(value) : value
    }));
  };

  const addItem = async () => {
    if (!newItem.nombre) return;
    const res = await fetch(`${API_URL}/api/inventario`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newItem)
    });
    const itemGuardado = await res.json();
    setInventory(prev => [...prev, itemGuardado]);
    setNewItem({ nombre: '', categoria: 'material', stock: 0, stockMinimo: 5 });
  };

  const updateStock = async (id, newStock) => {
    await fetch(`${API_URL}/api/inventario/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ stock: newStock })
    });
    fetchInventory();
  };

  const deleteItem = async (id) => {
    await fetch(`${API_URL}/api/inventario/${id}`, { method: 'DELETE' });
    setInventory(prev => prev.filter(item => item._id !== id));
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow border border-gray-200">
      <h2 className="text-xl font-semibold text-indigo-800 mb-6">🦷 Gestión de Inventario</h2>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-6">
        <input
          type="text"
          name="nombre"
          value={newItem.nombre}
          onChange={handleInputChange}
          placeholder="Nombre del insumo"
          className="border px-3 py-2 rounded"
        />
        <select
          name="categoria"
          value={newItem.categoria}
          onChange={handleInputChange}
          className="border px-3 py-2 rounded"
        >
          <option value="material">Material</option>
          <option value="medicamento">Medicamento</option>
          <option value="equipo">Equipo</option>
        </select>
        <input
          type="number"
          name="stock"
          value={newItem.stock}
          onChange={handleInputChange}
          placeholder="Stock"
          className="border px-3 py-2 rounded"
          min={0}
        />
        <button
          onClick={addItem}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          ➕ Agregar
        </button>
      </div>

      {inventory.length === 0 ? (
        <p className="text-gray-500">No hay insumos registrados.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full table-auto text-sm text-left border-collapse">
            <thead className="bg-indigo-50 text-indigo-700">
              <tr>
                <th className="px-4 py-2 border">Insumo</th>
                <th className="px-4 py-2 border">Categoría</th>
                <th className="px-4 py-2 border">Stock</th>
                <th className="px-4 py-2 border">Mínimo</th>
                <th className="px-4 py-2 border">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {inventory.map(item => (
                <tr key={item._id} className={item.stock < item.stockMinimo ? 'bg-red-50' : ''}>
                  <td className="px-4 py-2 border font-semibold">{item.nombre}</td>
                  <td className="px-4 py-2 border capitalize">{item.categoria}</td>
                  <td className="px-4 py-2 border">
                    <input
                      type="number"
                      value={item.stock}
                      onChange={(e) => updateStock(item._id, Number(e.target.value))}
                      className="w-20 border px-2 py-1 rounded"
                      min={0}
                    />
                  </td>
                  <td className="px-4 py-2 border">{item.stockMinimo}</td>
                  <td className="px-4 py-2 border">
                    <button
                      onClick={() => deleteItem(item._id)}
                      className="text-red-600 hover:underline"
                    >
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default InventoryManager;
